import React, { useEffect } from "react";
import { useChatTimerStore } from "@/store/chat-timer-store";

type ChatLoadingTimerProps = {
  className?: string;
};

export const ChatLoadingTimer: React.FC<ChatLoadingTimerProps> = ({
  className,
}) => {
  const { isGenerating, elapsedTime, updateElapsedTime } = useChatTimerStore();

  useEffect(() => {
    let intervalId: number | null = null;

    if (isGenerating) {
      intervalId = window.setInterval(() => {
        updateElapsedTime();
      }, 100);
    }

    return () => {
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
    };
  }, [isGenerating, updateElapsedTime]);

  if (!isGenerating) {
    return null;
  }

  const seconds = (elapsedTime / 1000).toFixed(1);

  return (
    <div className={`flex items-center text-sm ${className || ""}`}>
      <div className="mr-2 w-4 h-4 rounded-full border-2 border-t-transparent border-brand-primary animate-spin"></div>
      <span>Generating response... {seconds}s</span>
    </div>
  );
};
